import {Button, Card, CardBody, CardFooter, CardHeader, Input, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {PaymentReportGrid} from "./grid";
import {Paginator} from "../../system/paginator";
import {submitPaymentReport} from "../../../services/report/payment";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamily, getPersonsPhone} from "../../../services/profile/profile";
import FromToDateField from "../../system/fromToDateField";
import Dict from "../../../helper/dict";
import {downloadFile} from "../../../config";


export function PaymentReportManagement() {

  const [paymentReport, setPaymentReport] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(Date.now);
  const [gridRowCount, setGridRowCount] = useState(5);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  const [personId, setPersonId] = useState(null);
  const [amount, setAmount] = useState(null);
  const [referenceCode, setReferenceCode] = useState(null);
  const [endAtFrom, setEndAtFrom] = useState("")
  const [endAtTo, setEndAtTo] = useState("");
  const [status, setStatus] = useState(null);


  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    setFrom((gridCurrentPage - 1) * gridRowCount + 1)
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(data, paginate) {
    const result = await submitPaymentReport(data, paginate);
    if (result.status === 200) {
      const {payment_report, total_count} = result.data;
      setPaymentReport(payment_report || []);
      setGridTotalRowCount(total_count || 0)
    }
  }

  const filter = () => {
    const data = {}
    if (personId) {
      data.person_id = personId;
    }

    if (amount) {
      data.amount = parseInt(amount);
    }

    if (referenceCode) {
      data.reference_code = referenceCode;
    }

    if (endAtFrom) {
      data.end_at_from = endAtFrom;
    }

    if (endAtTo) {
      data.end_at_to = endAtTo;
    }

    if (status) {
      data.status = status;
    }

    return data
  };

  useEffect(() => {
    const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(data, paginate)
  }, [personId, endAtFrom, endAtTo, status, gridCurrentPage, gridRowCount, sortBy, sortType, lastDataRefresh]);


  return (
    <div className="w-full">
      <Card className="pt-8 w-full">
        <CardHeader floated={true} shadow={false} className="rounded-none w-full">
          <div className="mb-8 flex items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">واریزی‌ها</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">

          <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-3 xxl:grid-cols-3">

            <div className="flex flex-col">
              <SelectInput
                label={"نام"}
                defaultValue={personId}
                refreshSignal={personId}
                autoLoadService={getPersonsNameAndFamily}
                autoLoadRender={({name, family}) => {
                  return name + " " + family
                }}
                onChange={setPersonId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={Dict("phone")}
                defaultValue={personId}
                refreshSignal={personId}
                autoLoadService={getPersonsPhone}
                autoLoadRender={({phone}) => {
                  return phone
                }}
                onChange={setPersonId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"وضعیت"}
                options={[
                  {
                    "id": 'initiate',
                    "title": "در حال پرداخت"
                  },
                  {
                    "id": 'success',
                    "title": "پرداخت موفق"
                  },
                  {
                    "id": "failure",
                    "title": "پرداخت ناموفق"
                  },
                ]}
                onChange={setStatus}
              />
            </div>

            <div className="flex flex-col">
              <Input variant="static"
                     value={amount}
                     label={"مبلغ"}
                     placeholder={"مبلغ"}
                     onChange={(e) => {
                       setAmount(e.target.value)
                     }}
                     onBlur={(e) => {
                       setLastDataRefresh(Date.now())
                     }}
              />
            </div>

            <div className="flex flex-col">
              <Input variant="static"
                     value={referenceCode}
                     label={"مرچع"}
                     placeholder={"مرچع"}
                     onChange={(e) => {
                       setReferenceCode(e.target.value)
                     }}
                     onBlur={(e) => {
                       setLastDataRefresh(Date.now())
                     }}
              />
            </div>

          </div>

          <div className="flex flex-col md:flex-row">

            <div className="flex flex-row w-1/2 pb-4 mb-4 md:flex-col">
              <FromToDateField
                className="w-full"
                fromDate={endAtFrom}
                setFromDate={setEndAtFrom}
                toDate={endAtTo}
                setToDate={setEndAtTo}
                label="پرداخت"
              />
            </div>

          </div>

          <div className="flex flex-row justify-between">
            <Button variant="gradient" color="gray" onClick={() => {
              setPersonId(null)
              setEndAtFrom(null)
              setEndAtTo(null)
              setAmount(0)
              setReferenceCode("")
              setLastDataRefresh(Date.now())
            }} className="ml-1">
              <span>حذف فیلتر</span>
            </Button>

            {paymentReport.length > 0 &&
              <Button size="sm" variant="outlined" onClick={() => {
                const data = filter();
                downloadFile("payment_report_excel", data, "payments")
              }}>
                خروجی اکسل
              </Button>
            }
          </div>

          <PaymentReportGrid
            paymentReport={paymentReport}
            setSortBy={setSortBy}
            sortType={sortType}
            setSortType={setSortType}
          />

        </CardBody>
        <CardFooter className="flex justify-center border-t border-blue-gray-50 p-4">
          <Paginator
            active={gridCurrentPage}
            setActive={setGridCurrentPage}
            totalRows={gridTotalRowCount}
            rowsCount={gridRowCount}
            setRowsCount={setGridRowCount}
            from={from}
            to={to}
          />
        </CardFooter>
      </Card>
    </div>
  );
}